import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M12 2v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m4.93 4.93 1.41 1.41", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 12h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m19.07 4.93-1.41 1.41", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "CloudSun";
const CloudSun = memo(themed(Icon));
export {
  CloudSun
};
//# sourceMappingURL=cloud-sun.js.map
